import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const MyPosition = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.44 11C20.98 6.83 17.67 3.52 13.5 3.06V2C13.5 1.45 13.05 1 12.5 1C11.95 1 11.5 1.45 11.5 2V3.06C7.33 3.52 4.02 6.83 3.56 11H2.5C1.95 11 1.5 11.45 1.5 12C1.5 12.55 1.95 13 2.5 13H3.56C4.02 17.17 7.33 20.48 11.5 20.94V22C11.5 22.55 11.95 23 12.5 23C13.05 23 13.5 22.55 13.5 22V20.94C17.67 20.48 20.98 17.17 21.44 13H22.5C23.05 13 23.5 12.55 23.5 12C23.5 11.45 23.05 11 22.5 11H21.44ZM12.5 8C10.29 8 8.5 9.79 8.5 12C8.5 14.21 10.29 16 12.5 16C14.71 16 16.5 14.21 16.5 12C16.5 9.79 14.71 8 12.5 8ZM5.5 12C5.5 15.87 8.63 19 12.5 19C16.37 19 19.5 15.87 19.5 12C19.5 8.13 16.37 5 12.5 5C8.63 5 5.5 8.13 5.5 12Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default MyPosition;
